import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { TSS_DARK_BLUE, locationShape } from 'tss-core-lib-common';
import { HEADER_HEIGHT } from '../dimensions';

var styles = void 0;

var ErrorPage = function ErrorPage(_ref) {
  var code = _ref.code,
      location = _ref.location;

  var children = void 0;
  switch (code.toString()) {
    case '404':
      children = React.createElement(
        'p',
        { className: css(styles.info) },
        'Not Found'
      );
      if (location) {
        children = [React.createElement(
          'p',
          { className: css(styles.info), key: 'info' },
          'Not found'
        ), React.createElement(
          'p',
          { className: css(styles.location), key: 'location' },
          location.pathname || location
        )];
      }
      break;

    case '403':
      children = 'You don\'t have access to this resource';
      break;

    case '401':
      children = 'Access Denied';
      break;

    default:
      children = 'Unknown Error';
      break;
  }

  return React.createElement(
    'div',
    { className: css(styles.container) },
    children
  );
};

ErrorPage.propTypes = {
  code: PropTypes.string,
  location: locationShape
};

ErrorPage.defaultProps = {
  code: null,
  location: null
};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: '1.4rem',
    height: 'calc(100vh - ' + HEADER_HEIGHT + ' - 5vh)'
  },

  info: {
    fontSize: '10rem',
    fontWeight: 600,
    color: TSS_DARK_BLUE(0.2)
  },

  location: {
    color: TSS_DARK_BLUE(0.4)
  }
});

export default ErrorPage;